// Session storage keys specific to WLS application state
const WLS_SESSION_KEYS = {
    PIPELINE_ID: 'pipelineId'
    // Add other WLS-specific keys that need to be cleared on impersonation
    // Do NOT include 'spring-auth-access-token' or other auth-related keys
};

export const sessionStorageService = {
    /**
     * Clears only WLS application-specific session storage items
     * Does NOT clear authentication tokens or OAuth-related data
     */
    clear(): void {
        try {
            Object.values(WLS_SESSION_KEYS).forEach((key) => {
                sessionStorage.removeItem(key);
            });
        } catch (err) {
            console.error('Failed to clear WLS session storage:', err);
        }
    },

    /**
     * Use this only in logout scenarios where you want to clear everything
     */
    clearAll(): void {
        try {
            sessionStorage.clear();
        } catch (err) {
            console.error('Failed to clear all session storage:', err);
        }
    }
};
